document.addEventListener("DOMContentLoaded", function () {
  const cartNote = document.querySelector('#cart-note');

  if (localStorage.getItem('cartNoteValue')) {
    cartNote.value = localStorage.getItem('cartNoteValue');
  }
  cartNote.addEventListener('input', function () {
    localStorage.setItem('cartNoteValue', cartNote.value);
  });

  function attachGiftNoteHandler() {
    const giftNote = document.querySelector('#gift-note');
    if (giftNote) {
      if (localStorage.getItem('giftNoteValue')) {
        giftNote.value = localStorage.getItem('giftNoteValue');
      }
      giftNote.addEventListener('input', function () {
        localStorage.setItem('giftNoteValue', giftNote.value);
      });
    }
  }

  attachGiftNoteHandler();

  const observer = new MutationObserver(() => {
    attachGiftNoteHandler();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.querySelector('.check-out-btn')?.addEventListener('click', function () {
    localStorage.removeItem('cartNoteValue');
    localStorage.removeItem('giftNoteValue');
  });
});
